var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"slide-page carousel-slide pb-line-2",attrs:{"to":_vm.page.href}},[_c('h2',{staticClass:"txt-label t"},[_vm._v(_vm._s(_vm.page.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }